/* eslint-disable max-lines */
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import Picker from 'emoji-picker-react';
import LinearProgress from '@mui/material/LinearProgress';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import CloseIcon from '@mui/icons-material/Close';
import {
  Box,
  Popover,
  Alert,
  AlertTitle,
  Button,
  ButtonGroup,
  Tooltip
} from '@mui/material';
import { withStyles } from 'tss-react/mui';
import { SUGG_SMS } from '@lba-dev/package.local-globals/configTypes';
import { attachFile } from '@lba-dev/package.local-globals/utils';
import { Map } from 'immutable';
import { dayjs } from '@lba-dev/package.local-globals/dayjs';
import {
  WHATSAPPBUSINESS,
  resolveSmsMode
} from '@lba-dev/package.local-globals/smsMode';

import notifSystem from '../../../../../notifSystem';
import SuggestionsBar from '../SuggestionsBar';
import api from '../../../../../api';
import InputChat from './InputChat';
import { removeDivs } from '../../../constant';
import {
  isMaxFileOk, isMaxSizeOk,
  MAX_FILES, MAX_FILES_SIZE
} from '../../../../../utils/function';

const mapStateToProps = ({ users, config, connectedUser }) => ({
  user: connectedUser,
  users,
  config
});

const styles = (theme) => ({
  toolbar: {
    marginBottom: 2,
    border: '1px solid rgba(0,0,0,0.125)',
    borderRadius: 5,
    padding: '8px 16px',
  },
  linearDiv: {
    paddingLeft: 5,
    paddingRight: 5,
    borderRadius: 5,
    marginBottom: -1,
  },
  linear: {
    height: 2,
  },
  textField: {
    width: '100%',
    '& #editableinput': {
      whiteSpace: 'pre-wrap',
      width: '100%',
      height: 70,
      overflow: 'auto',
      outline: '0px solid transparent'
    },
    '& #editableinput>span::before': {
      content: '" "'
    },

  },
  uploadInput: {
    display: 'none'
  },
  audioBox: {
    display: 'flex',
    width: 368,
  },
  audioBoxHidden: {
    width: 0,
  },
  inputBox: {
    position: 'relative',
    width: '100%',
  },
  containerPaper: {
    position: 'absolute',
    width: '100%',
    bottom: '100%',
    minHeight: 50,
    overflow: 'hidden',
    maxHeight: 250,
    '& > ul': {
      overflow: 'auto',
      height: '90%',
      maxHeight: 203,
      paddingLeft: 0,
      margin: 0
    },
  },
  numberSelect: {
    '&::before': {
      borderWidth: '0px'
    },
    '& > div': {
      padding: '0px!important',
      lineHeight: 'normal',
      minHeight: 'auto!important'
    },
  },
  numberSelectIcon: {
    display: 'none'
  },
  selectValueNumber: {
    color: theme.palette.primary.main
  },
  serviceDiv: {
    position: 'sticky',
    bottom: 0,
    left: 0,
    right: 0,
    whiteSpace: 'nowrap',
    overflow: 'auto',
    boxShadow: theme.shadows[3],
    backgroundColor: '#fff'
  },
  fileAvatar: {
    width: 70,
    height: 70,
    borderRadius: 5,
    color: '#000',
    opacity: 0.4
  },
  fileDeleteIcon: {
    position: 'absolute',
    right: 18,
    top: 24
  }
});

const checkNumber = (number, dataObject) =>
  (dataObject.tels || []).find(e => e.tel === number) ? number : '';

const getStatusWBWindow = (status) => ({
  NO_PREVIOUS_MESSAGE: {
    canSend: false,
    reason: 'Pas de conversation WhatsApp Business initialisée',
    message: 'Veuillez notifier l\'artisan ou demander à l\'artisan '
      + 'de vous envoyer un message afin d\'initialiser la conversation.'
  },
  WINDOW_EXPIRED: {
    canSend: false,
    reason: 'Conversation WhatsApp Business expirée',
    message: 'Le dernier message reçu date de plus de 24h. \n'
      + 'Merci de notifier l\'artisan avec '
      + 'un message afin de réactualiser la conversation.'
  },
}[status])

class ChatInput extends PureComponent {
  constructor(props) {
    super(props);

    const selectedNumber = checkNumber(
      this.getLastNumber(), props.dataObject
    );
    this.state = {
      input: '',
      file: null,
      sending: false,
      showEmoji: false,
      showSmsSuggest: false,
      anchorEl: null,
      audioFile: null,
      selectedNumber,
      hasWhatsapp: !!props.hasWhatsapp,
      whatsappAlert: {
        message: null,
        title: null,
        canSend: true
      },
      sendingTmpMsg: false
    };
  }

  componentDidMount() {
    document.addEventListener('keydown', this.keydownHandler);
    const wc = this.checkWhatsAppWindow();
    if (!wc.canSend) {
      this.setState({
        whatsappAlert: {
          message: wc.message,
          title: wc.reason,
          canSend: wc.canSend,
        }
      });
    }
  }
  componentWillUnmount() {
    document.removeEventListener('keydown', this.keydownHandler);
  }

  keydownHandler = (e) => {
    if (this.state.input && e.key === 'Enter' && e.ctrlKey) {
      this.send();
    }
  };

  setInput = (value, callback = (e) => e) => {
    this.setState({ input: value, showSmsSuggest: false }, callback);
  }

  onEmojiClick = (event, emojiObject) => {
    this.setState({ input: this.state.input + emojiObject.emoji });
  };

  componentDidUpdate(prevProps, prevState) {
    let newAlert = null;

    // Bloc 1 : changement de numéro, tels, mode ou fenêtre WB
    if (
      prevState.selectedNumber !== this.state.selectedNumber ||
      JSON.stringify(prevProps.dataObject.smsMode) !==
      JSON.stringify(this.props.dataObject.smsMode) ||
      JSON.stringify(prevProps.dataObject.tels) !==
      JSON.stringify(this.props.dataObject.tels) ||
      JSON.stringify(prevProps.dataObject.windowTelsWB) !==
      JSON.stringify(this.props.dataObject.windowTelsWB)
    ) {
      const wc = this.checkWhatsAppWindow();
      if (!wc.canSend) {
        newAlert = {
          message: wc.message,
          title: wc.reason,
          canSend: wc.canSend
        };
      } else if (this.state.whatsappAlert.message) {
        newAlert = { message: null, title: null, canSend: true };
      }
    }

    // Bloc 2 : nouveau message reçu avec windowTelsWB mis à jour
    if (prevProps.data.size !== this.props.data.size) {
      const lastMessage = this.props.data.last();
      if (
        lastMessage?.size && !lastMessage.get('sender') &&
        lastMessage.hasIn(['artisanObject', 'windowTelsWB'])
      ) {
        const wc = this.checkWhatsAppWindow(
          undefined,
          {
            smsMode: this.props.dataObject.smsMode,
            tels: this.props.dataObject.tels ?? [],
            windowTelsWB: lastMessage.getIn(['artisanObject', 'windowTelsWB']),
          }
        );
        if (!wc.canSend) {
          newAlert = {
            message: wc.message,
            title: wc.reason,
            canSend: wc.canSend
          };
        } else if (this.state.whatsappAlert.message) {
          newAlert = {
            message: null,
            title: null,
            canSend: true
          };
        }
      }
    }

    if (newAlert) {
      this.setState({ whatsappAlert: newAlert });
    }
  }

  getLastNumber = () => {
    const lastElem = (this.props.data.last() || new Map()).toJS();
    return (this.props.selectedNumber || (
      lastElem.sender ? lastElem.to : lastElem.from) || ''
    ).replace('+33', '0');
  }

  getResolvedNumber = (dataObject) => {
    const d = dataObject ?? this.props.dataObject;
    return (
      this.state.selectedNumber ||
      checkNumber(this.getLastNumber(), d) ||
      d.tel1
    );
  }

  // Vérifier si on peut envoyer un message WhatsApp Business custom
  checkWhatsAppWindow = (selectedNumber, data) => {
    const { name } = this.props;
    const dataObject = data ?? this.props.dataObject;
    const numberToCheck = selectedNumber ?? this.getResolvedNumber(dataObject);


    // Vérifier uniquement pour les conversations artisan
    const telObject = dataObject.tels
      ?.findIndex(tel => tel.tel === numberToCheck);
    const telKey = telObject >= 0 ? `tel${telObject + 1}` : 'tel1';
    const resolvedMode = resolveSmsMode(dataObject?.smsMode, telKey);

    if (
      name !== 'artisan'
      || resolvedMode !== WHATSAPPBUSINESS
      || !dataObject?.tels?.length
      || !numberToCheck
    ) {
      return { canSend: true };
    }

    if (
      telObject === -1
      || Object.keys(dataObject.windowTelsWB ?? {}).length === 0
    ) {
      return getStatusWBWindow('NO_PREVIOUS_MESSAGE');
    }

    const windowExpiredAt = dataObject.windowTelsWB[telKey];

    if (windowExpiredAt && dayjs(windowExpiredAt).diff(
      dayjs(), 'second') < 0
    ) {
      return getStatusWBWindow('WINDOW_EXPIRED');
    }
    return { canSend: true };
  }

  sendMsgToResetWhatsAppWindow = async () => {
    const { name, dataObject, id } = this.props;
    const selectedNumber = this.getResolvedNumber();

    if (name !== 'artisan') {
      return;
    }

    try {
      this.setState({ sendingTmpMsg: true });
      await api.one('sms', id)
        .custom('sendMsgToResetWhatsAppWindow')
        .post({
          artisanId: dataObject.id,
          selectedNumber
        });
      notifSystem.success(
        'Artisan notifié',
        'L\'artisan a été notifié pour réinitialiser la conversation WhatsApp.'
      );
    } catch (error) {
      notifSystem.error(error.name, error.response ?
        error.response.data : error.message);
    } finally {
      this.setState({ sendingTmpMsg: false });
    }
  }

  handleCheckWBWindow = (status) => {
    let windowCheck;
    const updateAlert = (windowCheck) => {
      if (this.state.whatsappAlert.message === windowCheck.message) {
        return;
      }
      this.setState({
        whatsappAlert: {
          message: windowCheck.message,
          title: windowCheck.reason,
          canSend: windowCheck.canSend,
        }
      });
    };

    if (status) {
      windowCheck = getStatusWBWindow(status);
      updateAlert(windowCheck);
      return windowCheck;
    }

    const {
      hasWhatsapp
    } = this.state;

    if (hasWhatsapp) {
      windowCheck = this.checkWhatsAppWindow() ?? {};
      if (!windowCheck.canSend) {
        if (!this.state.whatsappAlert.message) {
          updateAlert(windowCheck);
        }
      }
      return windowCheck;
    }
    return { canSend: true };
  }

  send = () => {
    try {
      const {
        input, file, audioFile, selectedNumber, hasWhatsapp
      } = this.state;
      const {
        name: collection, id, user,
        filters, scroll, newContact
      } = this.props;

      if (!(input.trim() || file || audioFile)) {
        notifSystem.error('Erreur', 'Veuillez écrire un message');
        return;
      }

      // Vérifier la fenêtre WhatsApp Business si c'est WhatsApp
      const windowCheck = this.handleCheckWBWindow();
      if (windowCheck && !windowCheck.canSend) {
        return;
      }

      const message = audioFile ?
        '' : `${input}${user ? `\n\n${user.alias}` : ''}`;
      const uploadedFile = file;
      this.setState(
        {
          input: '',
          file: null,
          sending: true,
          audioFile: null,
          whatsappAlert: {
            message: null,
            title: null,
            canSend: true
          }
        },
        () => {
          api.one('sms', id)
            .custom('send')
            .post({
              message: removeDivs(message),
              collection,
              uploadedFile,
              newContact,
              filters: JSON.stringify(filters),
              hasWhatsapp,
              selectedNumber,
              audioFile,
            })
            .then(() => {
              scroll();
            })
            .catch(e => {
              if (e.response && [
                'NO_PREVIOUS_MESSAGE',
                'WINDOW_EXPIRED'
              ].includes(e.response.data)) {
                this.handleCheckWBWindow(e.response.data);
              } else {
                notifSystem.error(e.name, e.response ?
                  e.response.data : e.message)
              }
            })
            .finally(() => this.setState({ sending: false }));
        }
      );
    } catch (error) {
      notifSystem.error(error.name, error.response ?
        error.response.data : error.message);
    }
  }

  handleFile = (f) => {
    if (!f) {
      this.setState({ file: null });
      return;
    }
    attachFile(f.target.files[0])
      .then(file => {
        if (!isMaxSizeOk([file], MAX_FILES_SIZE)) {
          return notifSystem.error(
            'Erreur',
            'La taille totale dépasse la limite autorisée'
          );
        }
        if (!isMaxFileOk(1, MAX_FILES)) {
          return notifSystem.error(
            'Erreur',
            'Le nombre de fichiers dépasse la limite autorisée'
          );
        }
        this.setState({ file });
        f.target.value = null;
        return false;
      });
  }


  displaySuggestion = () => {
    const showSmsSuggest = this.state.showSmsSuggest;
    this.setState({ showSmsSuggest: !showSmsSuggest });
    this.props.scroll();
  };

  removeFile = () => this.setState({ file: null })

  showEmojiPicker = (e) =>
    this.setState({ anchorEl: e.currentTarget, showEmoji: true })

  handleAudio = (audio) => {
    this.setState({ audioFile: audio });
  }

  setSelectedNumber = (number) => {
    this.setState({ selectedNumber: number, hasWhatsapp: true });
  }

  render() {
    const { classes, name, users, dataObject, config } = this.props;
    const {
      showEmoji,
      showSmsSuggest,
      anchorEl,
      input,
      file,
      selectedNumber,
      audioFile,
      hasWhatsapp,
    } = this.state;
    const activeSmsSugestion = config.filter(
      u => u.type === SUGG_SMS && u.enable === true
    );

    return [
      showSmsSuggest && (
        <SuggestionsBar
          key={0}
          handleOnClick={this.setInput}
          suggestionsSms={activeSmsSugestion}
        />
      ),
      this.state.sending && (
        <div key={1} className={classes.linearDiv}>
          <LinearProgress className={classes.linear} />
        </div>
      ),
      this.state.whatsappAlert.message && (
        <Alert
          key={'whatsapp-alert'}
          severity="warning"
          action={
            <ButtonGroup
              color="inherit"
              size="small"
              variant='text'
              sx={{
                '& .MuiButton-root': {
                  padding: '2px 2px',
                },
              }}
            >
              <Tooltip title="Notifier l'artisan">
                <Button
                  disabled={this.state.sendingTmpMsg}
                  onClick={this.sendMsgToResetWhatsAppWindow}
                >
                  <NotificationsActiveIcon fontSize="small" />
                </Button>
              </Tooltip>
              <Tooltip title="Fermer">
                <Button
                  onClick={
                    () => this.setState(s => ({
                      ...s, whatsappAlert: {
                        ...s.whatsappAlert,
                        message: null
                      }
                    }))
                  }>
                  <CloseIcon fontSize='small' />
                </Button>
              </Tooltip>
            </ButtonGroup>
          }
        >
          <AlertTitle>{this.state.whatsappAlert.title}</AlertTitle>
          {this.state.whatsappAlert.message}
        </Alert>
      ),
      <Box key={2} className={classes.toolbar}>
        <InputChat
          {
            ...{
              value: input,
              handleAudio: this.handleAudio,
              audioFile,
              classes,
              name,
              hasWhatsapp,
              showSmsSuggest,
              file,
              handleFile: this.handleFile,
              displaySuggestion: this.displaySuggestion,
              removeFile: this.removeFile,
              send: this.send,
              showEmojiPicker: this.showEmojiPicker,
              setInput: this.setInput,
              users,
              dataObject,
              setSelectedNumber: this.setSelectedNumber,
              selectedNumber,
              canSend: this.state.whatsappAlert.canSend,
            }
          }
        />
      </Box>,
      <Popover
        key={3}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        anchorEl={anchorEl}
        open={showEmoji}
        onClose={() => this.setState({ showEmoji: false })}
      >
        <Picker onEmojiClick={this.onEmojiClick} />
      </Popover>,
    ];
  }
}
export default connect(mapStateToProps)(
  withStyles(ChatInput, styles)
);
